import React, { useState } from 'react'
import LoginLayout from 'Pages/Layout/LoginLayout'
import { userTokenSelector } from 'Store/customer/selector'
import { RootState } from 'Store'
import { connect, useDispatch } from 'react-redux'
import { Input, FormItem } from 'Components/form'
import { LoginReq, StaffLoginReq } from 'Store/user/types'
import { loginAPI, stafflLoginAPI } from 'Store/user/api'
import { selectEvent, selectLoginData } from 'Store/user/selector'
import { clearEventAction, updateCurrentUserAction } from 'Store/user/actions'
import EventModal from 'Components/modal/EventModal'
import InputPassword from 'Components/form/InputPassword'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { useNavigate } from 'react-router-dom'

type Props = {} & ReduxProps

const Login: React.FunctionComponent<Props> = props => {
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [username, setUsername] = useState<string>('')
  const [emailError, setEmailError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const [usernameError, setUsernameError] = useState(false)
  const [isMerchantLogin, setIsMerchantLogin] = useState(true)
  const { event, loginData } = props
  const history = useNavigate()

  const dispatch = useDispatch()

  const onLogin = (): void => {
    const req: LoginReq = {
      username: email?.trim() || '',
      password: password,
      grant_type: 'password',
      client_id: 'test',
      client_secret: 'test',
    }

    dispatch(loginAPI(req))
  }

  const onStaffLogin = (): void => {
    const req: StaffLoginReq = {
      username: username?.trim() || '',
      password: password,
    }

    dispatch(stafflLoginAPI(req))
  }

  const validateLogin = (): void => {
    if (isMerchantLogin && !email.trim()) {
      setEmailError(true)
      return
    }

    if (!isMerchantLogin && !username.trim()) {
      setUsernameError(true)
      return
    }

    if (!password.trim()) {
      setPasswordError(true)
      return
    }

    if (isMerchantLogin) {
      onLogin()
    } else {
      onStaffLogin()
    }
  }

  const onChangeEmail = (val: string): void => {
    setEmail(val)
    if (val && emailError) {
      setEmailError(false)
    }
  }

  const onChangeUsername = (val: string): void => {
    setUsername(val)
    if (val && usernameError) {
      setUsernameError(false)
    }
  }

  const onChangePassword = (val: string): void => {
    setPassword(val)
    if (val && passwordError) {
      setPasswordError(false)
    }
  }

  const errorStatus = (isError: boolean): string => {
    return isError ? 'error' : ''
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onSuccess = (): void => {
    clearEvent()
    history('/')
    dispatch(updateCurrentUserAction({ accessToken: (loginData && loginData.access_token) || '' }))
  }

  return (
    <>
      <EventModal event={[event]} enable={true} successCalback={onSuccess} errorCalback={clearEvent} />
      <LoginLayout
        title={`เข้าสู่ระบบสำหรับ${isMerchantLogin ? 'ร้านค้า' : 'พนักงาน'}`}
        onSubmit={validateLogin}
        onSwitchMode={setIsMerchantLogin}
        isMerchant={isMerchantLogin}
      >
        {isMerchantLogin && (
          <FormItem label="" status={errorStatus(emailError)} error="กรุณาระบุอีเมล">
            <Label>อีเมลเจ้าของร้าน</Label>
            <Input placeholder="อีเมล" value={email} onChange={onChangeEmail} key="email" type="email" />
          </FormItem>
        )}

        {!isMerchantLogin && (
          <FormItem label="" status={errorStatus(usernameError)} error="กรุณาระบุชื่อผู้ใช้งาน">
            <Label>ชื่อผู้ใช้งาน</Label>
            <Input placeholder="ชื่อผู้ใช้งาน" value={username} onChange={onChangeUsername} key="username" />
          </FormItem>
        )}
        {isMerchantLogin ? (
          <FormItem label="" status={errorStatus(passwordError)} error="กรุณาระบุรหัสผ่าน">
            <Label>รหัสผ่าน</Label>
            <InputPassword
              placeholder="รหัสผ่าน"
              key="password"
              value={password}
              onChange={onChangePassword}
            />
          </FormItem>
        ) : (
          <FormItem label="" status={errorStatus(passwordError)} error="กรุณาระบุรหัสผ่าน">
            <Label>รหัสผ่าน</Label>
            <InputPassword
              placeholder="รหัสผ่าน"
              key="staff-password"
              value={password}
              onChange={onChangePassword}
              resProps={{
                autoComplete: 'staff-password',
              }}
            />
          </FormItem>
        )}
      </LoginLayout>
    </>
  )
}

const Label = styled.span`
  font-size: 14px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const mapStateToProps = (state: RootState): any => {
  return {
    token: userTokenSelector(state),
    event: selectEvent(state),
    loginData: selectLoginData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(Login)
